import { Component, HostBinding, Input, OnInit, SimpleChanges } from '@angular/core';
import { IconImage, IconSize } from '@interfaces/common.interface';

@Component({
  selector: 'ark-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit {
  @Input() leftIcon: IconImage = '';
  @Input() iconSize: IconSize = 'small';
  @Input() rightIcon: IconImage = '';
  @Input() type:
    | 'primary'
    | 'secondary'
    | 'negative'
    | 'error'
    | 'light'
    | 'black'
    | 'flat'
    | 'icon'
    | 'fab'
    | 'transparent'
    | 'delete'
    | 'active'
    | 'confirmed'
    | 'convert-request'
    | 'light-secondary'
    | 'neutral' = 'primary';
  @Input() size:
    | 'tiny'
    | 'small'
    | 'middle'
    | 'xm'
    | 'medium'
    | 'large'
    | 'xl'
    | 'huge'
    | 'round' = 'medium';
  @Input() disabled: boolean | undefined = false;
  @Input() loading = false;
  @Input() deviceType = 'desktop';
  @Input() link = false;

  @Input() iconColor = '';
  loaderColor: 'light' | 'cta' | 'confirmed' | 'dark' = 'dark';

  @Input() classess = '';

  @HostBinding('style.pointer-events')
  get pointerEvents(): 'none' | null {
    return this.isInteractionBlocked ? 'none' : null;
  }

  @HostBinding('attr.aria-disabled')
  get ariaDisabled(): 'true' | null {
    return this.isInteractionBlocked ? 'true' : null;
  }

  constructor() {}

  ngOnInit(): void {
    this.updateColors();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['type']) {
      this.updateColors();
    }
  }

  private get shouldAutoSetIconColor(): boolean {
    return !this.iconColor;
  }

  private get isInteractionBlocked(): boolean {
    return !!this.disabled || this.loading;
  }

  private updateColors(): void {
    if (this.type === 'primary') {
      if (this.shouldAutoSetIconColor) {
        this.iconColor = 'light';
      }
      this.loaderColor = 'light';
    } else if (this.type === 'secondary') {
      if (this.shouldAutoSetIconColor) {
        this.iconColor = 'cta';
      }
      this.loaderColor = 'cta';
    } else if (this.type === 'delete') {
      if (this.shouldAutoSetIconColor) {
        this.iconColor = 'light';
      }
      this.loaderColor = 'light';
    } else if (this.type === 'active') {  
      if (this.shouldAutoSetIconColor) {
        this.iconColor = 'light';
      }
      this.loaderColor = 'light';
    } else if (this.type === 'confirmed') {  
      if (this.shouldAutoSetIconColor) {
        this.iconColor = 'confirmed';
      }
      this.loaderColor = 'confirmed';
    } else if (this.type === 'convert-request') {
      if (this.shouldAutoSetIconColor) {
        this.iconColor = 'light';
      }
      this.loaderColor = 'light';
    }
  }
}
